import { render, staticRenderFns } from "./ButtonsView.vue?vue&type=template&id=3238800c&scoped=true"
import script from "./ButtonsView.vue?vue&type=script&lang=js"
export * from "./ButtonsView.vue?vue&type=script&lang=js"
import style0 from "./ButtonsView.vue?vue&type=style&index=0&id=3238800c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1c848d52c9dbe574bb8312e4e1e1d32e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3238800c",
  null
  
)

export default component.exports